import { HttpClient } from '@adapters/HttpClient';

export interface PaymentMethodOption {
  id: string;
  name: string;
}

export class PaymentMethodsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<PaymentMethodOption[]> {
    const raw = await this.httpClient.get<any>('/payment-methods');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((method: any) => ({
      id: String(method.id),
      name: method.method || method.name,
    }));
  }
}
